import * as actionTypes from "../../actions/actionTypes";

const initialState = {
  loadingOmissionsByStudent: false,
  omissionsByStudent: [],
  faculty: "",
  loadingMonthStudentOmissionCounts: false,
  monthStudentOmissionCounts: []
};

const loadOmissionsByStudentRequest = (state) => {
    return {
      ...state,
      loadingOmissionsByStudent: true,
    };
};

const setOmissionsByStudentRequest = (state, action) => {
  return {
    ...state,
    omissionsByStudent: action.omissionsByStudent,
    faculty: action.faculty,
    loadingOmissionsByStudent: false,
  };
};

const loadMonthStudentOmissionCounts = (state) => {
    return {
      ...state,
      loadingMonthStudentOmissionCounts: true,
    };
};

const setMonthStudentOmissionCounts = (state, action) => {
  return {
    ...state,
    monthStudentOmissionCounts: action.monthStudentOmissionCounts,
    loadingMonthStudentOmissionCounts: false,
  };
};

const loadOmissionRequest = (state) => {
  return {
    ...state,
    loading: {
      loadOmissionRequest: true,
    },
  };
};

const loadOmissionRequestSuccess = (state, action) => {
  return {
    ...state,
    omissionRequests: action.payload,
    loading: {
      ...(state.loading),
      loadOmissionRequest: false
    },
  };
};

const loadOmissionRequestFailure = (state, action) => {
  return {
    ...state,
    loading: {},
    errors: {
      loadOmissionRequests: action.error,
    },
  };
};

const loadOmissionCertificateTypesSuccess = (state, action) => {
  return {
    ...state,
    omissionCertificateTypes: action.payload,
    loading: {
      ...(state.loading),
      loadOmissionCertificateTypesRequest: false
    }
  }
}

const loadOmissionCertificateTypesFailure = (state, action) => {
  return {
    ...state,
    omissionCertificateTypes: action.payload,
    errors: {
      loadOmissionCertificateTypes: action.error,
    },
  }
}

const createOmissionRequest = (state) => {
  return {
    ...state,
    loading: {
      createOmissionRequest: true,
    },
  };
};

const createOmissionRequestSuccess = (state, action) => {
  return {
    ...state,
    omissionRequests: action.payload,
    loading: {},
  };
};

const createOmissionRequestFailure = (state, action) => {
  return {
    ...state,
    loading: {},
    errors: {
      createOmissionRequest: action.error,
    },
  };
};


const updateOmissionRequest = (state) => {
  return {
    ...state,
    loading: {
      updateOmissionRequest: true,
    },
  };
};

const updateOmissionRequestSuccess = (state, action) => {
  return {
    ...state,
    updateOmissionRequest: action.payload,
    loading: {},
  };
};

const updateOmissionRequestFailure = (state, action) => {
  return {
    ...state,
    loading: {},
    errors: {
      updateOmissionRequest: action.error,
    },
  };
};


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOAD_OMISSIONS_BY_STUDENT:
      return loadOmissionsByStudentRequest(state);
    case actionTypes.SET_OMISSIONS_BY_STUDENT:
      return setOmissionsByStudentRequest(state, action);
    case actionTypes.LOAD_MONTH_STUDENT_OMISSION_COUNTS:
      return loadMonthStudentOmissionCounts(state);
    case actionTypes.SET_MONTH_STUDENT_OMISSION_COUNTS:
      return setMonthStudentOmissionCounts(state, action);
    case actionTypes.LOAD_OMISSION_REQUEST:
      return loadOmissionRequest(state);
    case actionTypes.LOAD_OMISSION_REQUEST_SUCCESS:
      return loadOmissionRequestSuccess(state, action);
    case actionTypes.LOAD_OMISSION_REQUEST_FAILURE:
      return loadOmissionRequestFailure(state, action);
    case actionTypes.CREATE_OMISSION_REQUEST:
      return createOmissionRequest(state);
    case actionTypes.CREATE_OMISSION_REQUEST_SUCCESS:
      return createOmissionRequestSuccess(state, action);
    case actionTypes.CREATE_OMISSION_REQUEST_FAILURE:
      return createOmissionRequestFailure(state, action);
    case actionTypes.LOAD_OMISSION_CERTIFICATE_TYPES_SUCCESS:
      return loadOmissionCertificateTypesSuccess(state, action);
    case actionTypes.LOAD_OMISSION_CERTIFICATE_TYPES_FAILURE:
      return loadOmissionCertificateTypesFailure(state, action);
    case actionTypes.UPDATE_OMISSION_REQUEST:
      return updateOmissionRequest(state);
    case actionTypes.UPDATE_OMISSION_REQUEST_SUCCESS:
      return updateOmissionRequestSuccess(state, action);
    case actionTypes.UPDATE_OMISSION_REQUEST_FAILURE:
      return updateOmissionRequestFailure(state, action);

    default:
      return state;
  }
};

export default reducer;